import { render, staticRenderFns } from "./BlacklistVerwalten.vue?vue&type=template&id=c6e5cfdc&"
import script from "./BlacklistVerwalten.vue?vue&type=script&lang=js&"
export * from "./BlacklistVerwalten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports